module.exports = __webpack_public_path__ + "img/499.ad951318.jpg";